const SmallButton = ({onClick,children})=> {
    return (
        <button onClick={onClick} className="text-white font-roboto border-0 rounded bg-gray-700 py-1.5 px-7 m-7 shadow-xl">{children}</button>
    )
}

export default SmallButton